module.exports = "/_next/static/images/11-138b0279c2241a551b1bf5dbd159f8f7.png";